import { Fragment, useEffect, useState, useMemo } from "react";
import axios from "axios";

//Redux
import { connect } from "react-redux";
import uiActions from "../../../../redux/ui/action";
import authActions from "../../../../redux/auth/action";
import userPreferenceActions from "../../../../redux/user_preference/action";

import "@fortawesome/fontawesome-free/css/all.min.css";
import HeaderLeft from "../../structure_components/desktop_screens/header_component_two/header_left/header_left";
import Header_component from "../../structure_components/desktop_screens/header_component/header_component";
import { ToastContainer } from "react-toastify";
import UserDayAttendance from "./userDayWise/UserDayAttendance";
import UserMonthAttendance from "./userMonthWise/UserMonthAttendance";
import UserDefaultAttendanceContent from "./UserDefaultAttendanceContent";
import LoaderPopUp from "../../../../components/loader/loader";
import { useLocation } from "react-router-dom";

function UserAttendance(props) {
  let { userPreference, setUser, setUserPreference, rollNo,loader } = props;
  const location = useLocation();
  const [isAnushaasan, setIsAnushaasan] = useState(null);
  const [activeTab, setActiveTab] = useState("day-wise");

  useEffect(() => {
    
    const isAnushaasanFromState = location.state?.isAnushaasan;
    if (isAnushaasanFromState !== undefined) {
      setIsAnushaasan(isAnushaasanFromState);
    } else {
     
      setIsAnushaasan(false); 
    }
  }, [location.state]);
  return (
    <>
      <ToastContainer />
      <Header_component />
      <HeaderLeft
        userPreference={userPreference}
        setUserPreference={setUserPreference}
        setUser={setUser}
      />
      <div className="user-attendance-wrapper">
        {isAnushaasan === null ? (
          <div>Loading...</div>
        ) : !isAnushaasan ? (
          <div className="attendance-content-container">
            <UserDefaultAttendanceContent />
          </div>
        ) : (
          <div className="attendance-wrapper">
            <div className="attendance-container">
              <div className="attendance-tab-header">
                <button
                  className={`attendance-tab ${
                    activeTab === "day-wise" ? "active-tab" : ""
                  }`}
                  onClick={() => setActiveTab("day-wise")}
                >
                  Day-wise Attendance
                </button>
                <button
                  className={`attendance-tab ${
                    activeTab === "monthly" ? "active-tab" : ""
                  }`}
                  onClick={() => setActiveTab("monthly")}
                >
                  Monthly Attendance
                </button>
              </div>

              <div className="attendance-tab-content">
                {activeTab === "day-wise" ? (
                  <UserDayAttendance />
                ) : (
                  <UserMonthAttendance />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      {loader && <LoaderPopUp/>}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    token: state.auth.authToken,
    tokenType: state.auth.authType,
    currentRefundPackage: state.RefundPackageSliceReducer.refundCurrentPackage,
    rollNo: state.auth.user.roll_no,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setUser: (payload) => {
      dispatch(authActions.setUser(payload));
    },
    setUserPreference: (payload) => {
      dispatch(userPreferenceActions.setUserPreference(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAttendance);
